import {
  Modal,
  Box,
  Typography,
  Button,
  Alert
} from '@mui/material';
import { useTranslation } from "react-i18next";

export default function ModalSave({
  openState,
  handleYesModal,
  handleNoModal
}) {
  const { t } = useTranslation();

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: '16px',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  return (
    <Modal
      open={openState}
    >
      <Box sx={{ ...modalStyle }}>
        <Typography variant="h5" component="h2">
          {t("dialogs.confirm_configuration.title")}
        </Typography>
        <Box mt={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant="contained" color="error" onClick={handleNoModal}>
            {t("dialogs.buttons.no")}
          </Button>
          <Button variant="contained" color="primary" onClick={handleYesModal} sx={{ ml: 2, }}>
            {t("dialogs.buttons.yes")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}